export function formatNumber(number: any, options: any) {
  if (number >= 1000000000) {
    const formatter = new Intl.NumberFormat("id-ID");
    let formattedNumber = number / 1000000000;
    return `${formatter.format(formattedNumber)} M`;
  }
  const formatter = new Intl.NumberFormat("id-ID", options);
  return formatter.format(number);
}
